import React from 'react';
import PropTypes from 'prop-types';
import { Steps, Button, message, Col, Row, Typography } from 'antd';
import { KYC_STATUS } from 'constants/status';
import { ExclamationCircleFilled, RightOutlined } from '@ant-design/icons';
import Alert from 'components/Alert';
import merchantAPI from 'services/merchants';
import styled from 'styled-components';
import kycCard from 'assets/images/kyc_card.webp';
import trackingService from 'services/trackingService';
import EVENT_NAME from 'utils/const';

const StepsWrapper = styled.div`
  .ant-steps .ant-steps-item-finish.ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
    color: #fbbc04;
  }
`;
const kycVerify = async (merchantId) => {
  message.info({
    content: 'Fetching Kyc verification link'
  });

  const response = await merchantAPI.kycVerify({ merchant_id: merchantId });

  if (response.success) {
    window.open(response.data.redirection_url);
    message.info({
      content: 'You are being redirected to link'
    });
  } else {
    console.log('something went wrong');
    Alert('something went wrong', 'Please contact support team for this', 'error');
  }
};

function KycCard({
  bankStatus,
  businessStatus,
  basicStatus,
  merchantId,
  updateKyc,
  isKycComplete
}) {
  return (
    <div
      style={{
        padding: '6%',
        height: '100%',
        borderRadius: '13px',
        // backgroundImage: 'linear-gradient(to bottom left, rgba(204, 219, 255), rgba(232, 255, 247))'
        background: `url(${kycCard}) no-repeat`,
        backgroundSize: 'cover'
      }}
    >
      <Typography.Title
        level={4}
        style={{ margin: '0', alignItems: 'center', letterSpacing: '0px' }}
      >
        KYC
      </Typography.Title>
      <StepsWrapper>
        <Steps
          current={3}
          direction="vertical"
          items={[
            {
              title: `Basic Profile (${KYC_STATUS[basicStatus].label})`,
              icon: <ExclamationCircleFilled style={{ fontSize: '16px' }} />
            },
            {
              title: `Bank Details (${KYC_STATUS[bankStatus].label})`,
              icon: <ExclamationCircleFilled style={{ fontSize: '16px' }} />
            },
            {
              title: `Business Details (${KYC_STATUS[businessStatus].label})`,
              icon: <ExclamationCircleFilled style={{ fontSize: '16px' }} />
            }
          ]}
        />
      </StepsWrapper>
      {updateKyc && updateKyc !== undefined ? (
        <Row justify="end">
          <Col xs={{ span: 18 }} lg={{ span: 18 }} md={{ span: 18 }}>
            <Row justify="end">
              <Button
                type="primary"
                size="large"
                style={{
                  boxShadow: '0px 3px 6px #0000000f'
                  // marginTop: '7%'
                }}
                onClick={() => {
                  trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, { name: 'Complete Kyc' });
                  kycVerify(merchantId);
                }}
              >
                {isKycComplete ? 'View & Update Kyc' : 'Complete KYC'} <RightOutlined />
              </Button>
            </Row>
          </Col>
        </Row>
      ) : (
        <Row justify="end">
          <Col xs={{ span: 18 }} lg={{ span: 18 }} md={{ span: 18 }}>
            <Row justify="end">
              <Button
                type="primary"
                size="large"
                style={{
                  boxShadow: '0px 3px 6px #0000000f'
                  // marginTop: '7%'
                }}
                onClick={() =>
                  Alert("You don't have access", 'Please contact support team for this', 'info')
                }
              >
                Complete Kyc
              </Button>
            </Row>
          </Col>
        </Row>
      )}
    </div>
  );
}

KycCard.propTypes = {
  bankStatus: PropTypes.string.isRequired,
  businessStatus: PropTypes.string.isRequired,
  basicStatus: PropTypes.string.isRequired,
  merchantId: PropTypes.number.isRequired,
  updateKyc: PropTypes.bool.isRequired,
  isKycComplete: PropTypes.bool.isRequired
};

export default KycCard;
